import { useEffect } from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

export default function useFormFocus<T extends FieldValues>(
  methods: UseFormReturn<T>,
  autoFocus: boolean
) {
  useEffect(() => {
    const keys = Object.keys(methods.control._fields);

    const timeout = setTimeout(() => {
      try {
        if (autoFocus) {
          // eslint-disable-next-line no-underscore-dangle
          methods.control._fields[keys[0]]?._f?.ref?.focus?.();
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }, 200);

    return () => clearTimeout(timeout);
  }, []);
}
